<section class="resume-section" id="resume">
  <div class="resume-container">
    <div>
      <span class="resume-overline">Resume Builder</span>
      <h2 class="resume-title">
        Build an <span class="brand-gradient-text">ATS-ready</span><br class="hidden sm:block" /> resume in minutes
      </h2>
      <p class="resume-description">
        Stop guessing what recruiters want. Our AI resume builder scores your
        resume against real job descriptions and shows you exactly how to stand
        out.
      </p>
      <ul class="mt-6 space-y-3">
        <li class="flex items-center gap-2.5 text-slate-700 text-sm font-semibold">
          <svg class="w-5 h-5 text-emerald-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          Recruiter-approved templates
        </li>
        <li class="flex items-center gap-2.5 text-slate-700 text-sm font-semibold">
          <svg class="w-5 h-5 text-emerald-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          Real-time ATS score &amp; keyword tips
        </li>
        <li class="flex items-center gap-2.5 text-slate-700 text-sm font-semibold">
          <svg class="w-5 h-5 text-emerald-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          Export to PDF in one click
        </li>
      </ul>
      <button class="btn-resume group" data-testid="resume-cta" routerLink="/login">
        Build ATS Resume
        <svg aria-hidden="true" class="lucide lucide-arrow-right w-4 h-4" fill="none" stroke="currentColor"
          stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M5 12h14"></path>
          <path d="m12 5 7 7-7 7"></path>
        </svg>
      </button>
    </div>

    <div class="mock-resume-wrapper">
      <div class="mock-bg-glow"></div>

      <div class="mock-resume-card">
        <div class="flex items-center gap-4 border-b border-slate-100 pb-4">
          <div class="avatar-box">AS</div>
          <div class="flex-1">
            <p class="font-display font-bold text-slate-900 leading-tight">Ananya Sharma</p>
            <p class="text-xs text-indigo-600 font-medium">Frontend Engineer</p>
            <div class="mt-1.5 flex flex-wrap gap-x-3 gap-y-1 text-[10px] text-slate-400">
              <span class="inline-flex items-center gap-1">
                <svg aria-hidden="true" class="lucide lucide-mail w-2.5 h-2.5" fill="none" height="24"
                  stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                  <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                  <rect height="16" rx="2" width="20" x="2" y="4"></rect>
                </svg>
                ananya&#64;mail.com
              </span>
              <span class="inline-flex items-center gap-1">
                <svg aria-hidden="true" class="lucide lucide-phone w-2.5 h-2.5" fill="none" height="24"
                  stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384">
                  </path>
                </svg>
                +91 98••• •••21
              </span>
              <span class="inline-flex items-center gap-1">
                <svg aria-hidden="true" class="lucide lucide-map-pin w-2.5 h-2.5" fill="none" height="24"
                  stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0">
                  </path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
                Bengaluru
              </span>
            </div>
          </div>
        </div>

        <div class="mt-4 grid grid-cols-3 gap-4">
          <div class="col-span-2 space-y-4">
            <div>
              <p class="text-[10px] font-bold uppercase tracking-widest text-indigo-500 mb-2">Experience</p>
              <div class="space-y-1.5">
                <div class="h-2 w-2/3 rounded bg-slate-200"></div>
                <div class="h-1.5 rounded bg-slate-100"></div>
                <div class="h-1.5 w-5/6 rounded bg-slate-100"></div>
                <div class="h-1.5 w-4/6 rounded bg-slate-100"></div>
              </div>
            </div>
            <div>
              <p class="text-[10px] font-bold uppercase tracking-widest text-indigo-500 mb-2">Education</p>
              <div class="space-y-1.5">
                <div class="h-2 w-2/3 rounded bg-slate-200"></div>
                <div class="h-1.5 rounded bg-slate-100"></div>
                <div class="h-1.5 w-5/6 rounded bg-slate-100"></div>
                <div class="h-1.5 w-4/6 rounded bg-slate-100"></div>
              </div>
            </div>
          </div>
          <div>
            <p class="text-[10px] font-bold uppercase tracking-widest text-indigo-500 mb-2">Skills</p>
            <div class="flex flex-wrap gap-1.5">
              <span class="rounded-md bg-indigo-50 px-2 py-0.5 text-[10px] font-medium text-indigo-600">React</span>
              <span
                class="rounded-md bg-indigo-50 px-2 py-0.5 text-[10px] font-medium text-indigo-600">TypeScript</span>
              <span class="rounded-md bg-indigo-50 px-2 py-0.5 text-[10px] font-medium text-indigo-600">CSS</span>
              <span class="rounded-md bg-indigo-50 px-2 py-0.5 text-[10px] font-medium text-indigo-600">Node</span>
              <span class="rounded-md bg-indigo-50 px-2 py-0.5 text-[10px] font-medium text-indigo-600">UI</span>
            </div>
          </div>
        </div>
      </div>

      <div class="ats-score-card">
        <div class="flex items-center gap-2 mb-3">
          <span class="grid place-items-center w-7 h-7 rounded-lg bg-emerald-500 text-white">
            <svg aria-hidden="true" class="lucide lucide-zap w-3.5 h-3.5" fill="none" height="24" stroke="currentColor"
              stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z">
              </path>
            </svg>
          </span>
          <p class="text-xs font-bold text-slate-900">ATS Score</p>
          <span class="ml-auto text-[10px] font-semibold text-emerald-600">Excellent</span>
        </div>
        <div class="flex items-center gap-4">
          <div class="relative w-[72px] h-[72px] shrink-0">
            <svg class="-rotate-90" height="72" viewBox="0 0 72 72" width="72">
              <circle cx="36" cy="36" fill="none" r="30" stroke="#eef1ff" stroke-width="8"></circle>
              <circle cx="36" cy="36" fill="none" r="30" stroke="url(#atsGrad)" stroke-dasharray="188.49555921538757"
                stroke-dashoffset="7.5398" stroke-linecap="round" stroke-width="8"></circle>
              <defs>
                <linearGradient id="atsGrad" x1="0" x2="1" y1="0" y2="1">
                  <stop stop-color="#10b981"></stop>
                  <stop offset="1" stop-color="#4f46e5"></stop>
                </linearGradient>
              </defs>
            </svg>
            <div class="absolute inset-0 grid place-items-center">
              <span class="font-display text-lg font-extrabold text-slate-900">96%</span>
            </div>
          </div>
          <div class="flex-1 space-y-2">
            <div>
              <div class="flex justify-between text-[9px] text-slate-500 mb-0.5">
                <span>Keywords</span><span class="font-semibold text-slate-700">92%</span>
              </div>
              <div class="progress-bar-bg">
                <div class="progress-bar-fill" style="width: 92%;"></div>
              </div>
            </div>
            <div>
              <div class="flex justify-between text-[9px] text-slate-500 mb-0.5">
                <span>Format</span><span class="font-semibold text-slate-700">98%</span>
              </div>
              <div class="progress-bar-bg">
                <div class="progress-bar-fill" style="width: 98%;"></div>
              </div>
            </div>
            <div>
              <div class="flex justify-between text-[9px] text-slate-500 mb-0.5">
                <span>Readability</span><span class="font-semibold text-slate-700">90%</span>
              </div>
              <div class="progress-bar-bg">
                <div class="progress-bar-fill" style="width: 90%;"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ai-suggestions-card">
        <span class="grid place-items-center w-9 h-9 rounded-xl bg-amber-400 text-white">
          <svg aria-hidden="true" class="lucide lucide-wand-sparkles w-4 h-4" fill="none" height="24"
            stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"
            width="24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72">
            </path>
            <path d="m14 7 3 3"></path>
            <path d="M5 6v4"></path>
            <path d="M19 14v4"></path>
            <path d="M10 2v2"></path>
            <path d="M7 8H3"></path>
            <path d="M21 16h-4"></path>
            <path d="M11 3H9"></path>
          </svg>
        </span>
        <div>
          <p class="text-xs font-bold text-slate-900">AI Suggestions</p>
          <p class="text-[10px] text-slate-500">Add 3 keywords</p>
        </div>
      </div>
    </div>
  </div>
</section>
